import { InterpolationWithTheme } from "@emotion/core";
import { FlowContext } from "../../utils/EventTrackerConstants";


export const inAppNotificationStyles: { [key: string]: any } = {
    notificationContainer: {
        position: "fixed",
        width: "305px",
        top: "10px",
        background: "lightgray",
        borderRadius: "5px 0px 0px 5px",
        zIndex: 9999999999,
        height: "65px",
        right: 0,
        display: "flex",
        paddingLeft: "10px"
    },

    notificationLeft: {
        display: "flex",
        flex: 2,
        borderRight: "2px solid #c4bfbf",
        alignItems: "center"
    },

    notifiactionIconContainer: {
        display: "flex",
        alignItems: "center",
        textAlign: "center"
    },

    notificationTextContainer: {
        display: "flex",
        textAlign: "left",
        alignItems: "center",
        marginLeft: "10px"
    },

    notificationIcon: {
        width: "40px",
        background: "#ffffff",
        height: "40px",
        borderRadius: "50%",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "14px",
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },

    notifiactionTitle: {
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "14px"
    },

    notificationSubTitle: {
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: "11px"
    },

    notificationRight: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "11px",
        color: "#ff316d",
        textAlign: "center"
    },
    notificationActionTop: {
        borderBottom: "2px solid #c4bfbf",
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"

    },
    notificationActionBottom: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        position: "relative"
    },
    delayOptionsContainer: (show: boolean) => {
        const styles = {
            width: "100%",
            position: "absolute",
            bottom: -30,
            background: "rgba(145, 151, 171, 0.8)",
            borderRadius: "0px 0px 5px 5px",
            zIndex: -1,
            opacity: 0,
            pointerEvents: "none",
            transition: "all 0.2s"
        }
        if (show) {
            styles.opacity = 1
            styles.pointerEvents = "auto"
            styles.bottom = -50
        }
        return styles
    },
    delayOption: {
        padding: "5px 0",
        color: "white",
        textAlign: "center"
    },
    successText: {
        fontSize: 12,
        margin: "0 5px",
        fontFamily: "BrandonTextWeb-Medium"
    }
}
